import { Col, Row } from "react-bootstrap";
import { IViewSolarEstimationSolarProduct } from "../../../../../shared/oversight-core/interfaces/view-solar-estimation-solar-product";
import MaterialIcon from "../../../../../shared/oversight-core/ui-elements/material-icon/material-icon";
import { formatWithCommas } from "../../../../../shared/oversight-core/utils/format-with-commas";
import Helper from "../../../../../shared/oversight-core/utils/helpers";
import { getSolarProductIcon } from "../../../../../shared/oversight-core/utils/solar-product-icon";
import styles from "./purchase-solar-component.module.scss";

interface IProps {
  product: IViewSolarEstimationSolarProduct;
  count: number;
}

const PurchaseSolarComponent = (props: IProps) => {
  const { product, count } = props;

  const { name, price, currency } = product;

  return (
    <div
      className={`px-3 py-2 rounded-3 bg-white ${styles.purchaseSolarComponent}`}
    >
      <Row className="align-items-center justify-content-between">
        <Col xl={8}>
          <Row className="align-items-center">
            <Col className="col-auto">
              <MaterialIcon
                icon={getSolarProductIcon(product.category)}
                color="#545F71"
              />
            </Col>
            <Col xl={6} className="text-dark-4 font-weight-500 font-size-16">
              {name}
            </Col>
            <Col className="col-auto text-gray-13 font-weight-500 font-size-12">
              {currency}&nbsp;{formatWithCommas(Number(Helper.roundTo2(price)))}
            </Col>
          </Row>
        </Col>
        <Col>
          <Row className="align-items-center gap-5">
            <Col xl={2} className="text-dark-4 font-weight-600">
              x{count}
            </Col>
            <Col className="text-dark-4 font-weight-600 text-end">
              {currency}&nbsp;
              {formatWithCommas(Number(Helper.roundTo2(count * price)))}
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default PurchaseSolarComponent;
